(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');

  function initFeatureBlocks(section) {
    var panels = section.querySelectorAll('.mt-feature-blocks__panel');
    var bgItems = section.querySelectorAll('.mt-feature-blocks__bg-item');
    var stage = section.querySelector('[data-feature-stage]');
    var prevBtn = section.querySelector('[data-feature-prev]');
    var nextBtn = section.querySelector('[data-feature-next]');
    var mobileTitle = section.querySelector('[data-feature-mobile-title]');
    var mobileDesc = section.querySelector('[data-feature-mobile-desc]');

    if (!bgItems.length) return;

    var count = bgItems.length;
    var currentIndex = 0;
    var touchStartX = 0;
    var touchStartY = 0;

    function getSlideIndex(el) {
      return parseInt(el.getAttribute('data-index'), 10) || 0;
    }

    function getBgBySlideIndex(index) {
      for (var i = 0; i < bgItems.length; i++) {
        if (getSlideIndex(bgItems[i]) === index) {
          return bgItems[i];
        }
      }
      return bgItems[0];
    }

    bgItems.forEach(function (item) {
      if (item.classList.contains('is-active')) {
        currentIndex = getSlideIndex(item);
      }
    });

    function updateMobileInfo(index) {
      if (!MOBILE_MQ.matches) return;

      var item = getBgBySlideIndex(index);
      if (!item) return;

      var title = item.getAttribute('data-title') || '';
      var desc = item.getAttribute('data-desc') || '';

      if (mobileTitle) {
        mobileTitle.textContent = title;
        if (title) {
          mobileTitle.removeAttribute('hidden');
        } else {
          mobileTitle.setAttribute('hidden', '');
        }
      }

      if (mobileDesc) {
        mobileDesc.textContent = desc;
        if (desc) {
          mobileDesc.removeAttribute('hidden');
        } else {
          mobileDesc.setAttribute('hidden', '');
        }
      }
    }

    function setActive(index) {
      currentIndex = ((index % count) + count) % count;

      bgItems.forEach(function (bg) {
        bg.classList.toggle('is-active', getSlideIndex(bg) === currentIndex);
      });

      if (!MOBILE_MQ.matches) {
        panels.forEach(function (panel) {
          var isActive = getSlideIndex(panel) === currentIndex;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
      }

      updateMobileInfo(currentIndex);
    }

    panels.forEach(function (panel) {
      panel.addEventListener('click', function () {
        if (MOBILE_MQ.matches) return;

        if (panel.classList.contains('is-active')) {
          panel.classList.remove('is-active');
          panel.setAttribute('aria-expanded', 'false');
          return;
        }
        setActive(getSlideIndex(panel));
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        setActive(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        setActive(currentIndex + 1);
      });
    }

    if (stage) {
      stage.addEventListener(
        'touchstart',
        function (e) {
          if (!MOBILE_MQ.matches || e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchend',
        function (e) {
          if (!MOBILE_MQ.matches || e.changedTouches.length !== 1) return;

          var diffX = e.changedTouches[0].clientX - touchStartX;
          var diffY = e.changedTouches[0].clientY - touchStartY;

          if (Math.abs(diffX) < 40 || Math.abs(diffX) < Math.abs(diffY)) return;

          if (diffX < 0) {
            setActive(currentIndex + 1);
          } else {
            setActive(currentIndex - 1);
          }
        },
        { passive: true }
      );
    }

    updateMobileInfo(currentIndex);
  }

  function initAll() {
    document.querySelectorAll('.mt-feature-blocks[data-section-id]').forEach(initFeatureBlocks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.mt-feature-blocks[data-section-id]');
    if (section) initFeatureBlocks(section);
  });
})();
